import { AlignmentType, FrameAnchorType, HorizontalPositionAlign, Paragraph, TextRun, VerticalPositionAlign, WidthType } from "docx";


export function reportAppName(certInApplicationName) {
    return new Paragraph({
        width: { size: 50, type: WidthType.PERCENTAGE },
        alignment: AlignmentType.CENTER,
        spacing: { line: 276, before: 100, after: 100 },
        frame: {
            type: "absolute",
            position: {
                x: 700,
                y: 6000,
            },
            width: 9000,
            height: 1000,
            anchor: {
                horizontal: FrameAnchorType.MARGIN,
                vertical: FrameAnchorType.MARGIN,
            },
            alignment: {
                x: HorizontalPositionAlign.CENTER,
                y: VerticalPositionAlign.CENTER,
            },
            zIndex: 90,
        },

        children: [
            new TextRun({
                text: `Security Audit Phase 1 Report ${certInApplicationName} Mobile Application`,
                font: "Calibri",
                size: 56,
                color: '0070C0',
                allCaps: false,
                italics: false
            }),
        ],
    });
}
